import { render, staticRenderFns } from "./wxloding.vue?vue&type=template&id=682bec0c&scoped=true&"
import script from "./wxloding.vue?vue&type=script&lang=js&"
export * from "./wxloding.vue?vue&type=script&lang=js&"
import style0 from "./wxloding.vue?vue&type=style&index=0&id=682bec0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682bec0c",
  null
  
)

export default component.exports